<script>
  // Перенос src_ui/web/src/screens/Auth.tsx — ДОСЛОВНО (та же разметка/классы/логика,
  // поменялась только обвязка React→Svelte). 4 режима: welcome/login/register/forgot.
  import { nuiPost, autofocus } from './nui';
  import Brand from './brand.svelte';
  import PassField from './authpass.svelte';

  export let known = null;   // логин аккаунта, привязанного к этому Social Club
  export let quick = false;  // разрешён ли вход без пароля
  export let newAcc = false; // сервер ЯВНО сказал: аккаунта нет → показать регистрацию
  export let result = null;  // последний authResult от сервера
  export let onLoading = () => {};

  const LOGIN_RE = /^[a-zA-Z0-9_]{3,20}$/;

  // 🔴 Дефолт — ВХОД, а не регистрация. Раньше при known=null (нет данных ИЛИ
  // сервер сказал «нет аккаунта») всегда показывалась регистрация — и если
  // состояние не доехало (браузер перестроился), существующий игрок видел
  // регистрацию вместо входа. Как у штатной формы: по умолчанию вход, а
  // регистрацию включаем только по явному сигналу сервера newAcc.
  let mode = known ? (quick ? 'welcome' : 'login') : (newAcc ? 'register' : 'login');
  let login = known ?? '';
  let password = '';
  let showPass = false;
  let remember = true;
  let error = '';

  // регистрация
  let regPass = '';
  let regPass2 = '';
  let rules = false;
  let email = '';
  let promo = '';

  // восстановление
  let stage = 1;
  let fPass = '';
  let fPass2 = '';

  // useEffect [known, quick, newAcc] — реагируем ТОЛЬКО на смену этих входов (не на mode)
  let _pKnown = known, _pQuick = quick, _pNewAcc = newAcc, _initKQ = true;
  $: if (_initKQ || known !== _pKnown || quick !== _pQuick || newAcc !== _pNewAcc) {
    _initKQ = false; _pKnown = known; _pQuick = quick; _pNewAcc = newAcc;
    // не перебиваем ручной выбор игрока (forgot / он сам открыл регистрацию)
    if (known && mode !== 'forgot' && mode !== 'register') {
      mode = quick ? 'welcome' : 'login';
      if (!login) login = known;
    } else if (!known && newAcc && (mode === 'login' || mode === 'welcome')) {
      // аккаунта под этим Social Club нет — сервер подтвердил, ведём на регистрацию
      mode = 'register';
    }
  }

  // useEffect [result] — ответы сервера
  let _pResult = null;
  $: if (result !== _pResult) {
    _pResult = result;
    if (result) {
      if (result.mode === 'forgot') {
        if (result.ok && result.stage === 'verified') { stage = 2; error = ''; }
        else if (result.ok && result.stage === 'done') { stage = 3; error = ''; }
        else if (!result.ok) error = result.error ?? 'Что-то пошло не так';
      } else if (!result.ok) {
        error = result.error ?? 'Что-то пошло не так';
      }
    }
  }

  const clearErr = () => { error = ''; };

  const submitLogin = () => {
    if (!LOGIN_RE.test(login.trim())) { error = 'Логин: 3–20 символов — латиница, цифры или «_».'; return; }
    if (password.length < 6) { error = 'Пароль — минимум 6 символов.'; return; }
    error = '';
    onLoading('Подключение к Social Club');
    nuiPost('authSubmit', { mode: 'login', username: login.trim(), password, remember });
  };

  const quickLogin = () => {
    error = '';
    onLoading('Вход без пароля');
    nuiPost('quickLogin', { username: known, remember });
  };

  const submitRegister = () => {
    const lg = login.trim();
    if (/[А-Яа-яЁё]/.test(lg)) { error = 'Логин — только латиницей. Например: VLADIK_M.'; return; }
    if (!LOGIN_RE.test(lg)) { error = 'Логин: 3–20 символов — латиница, цифры или «_».'; return; }
    if (regPass.length < 6) { error = 'Пароль слишком короткий — минимум 6 символов.'; return; }
    if (regPass !== regPass2) { error = 'Пароли не совпадают.'; return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim())) { error = 'Укажи настоящий email — на него восстановишь доступ.'; return; }
    if (!rules) { error = 'Нужно принять правила сервера.'; return; }
    error = '';
    onLoading('Создание аккаунта');
    nuiPost('authSubmit', { mode: 'register', username: lg, password: regPass, email: email.trim(), promo: promo.trim(), remember });
  };

  const forgotCheck = () => {
    if (!LOGIN_RE.test(login.trim())) { error = 'Укажи логин аккаунта (3–20 символов).'; return; }
    error = '';
    onLoading('Проверка владения');
    nuiPost('authForgot', { username: login.trim(), check: true });
  };

  const forgotReset = () => {
    if (fPass.length < 6) { error = 'Новый пароль — минимум 6 символов.'; return; }
    if (fPass !== fPass2) { error = 'Пароли не совпадают.'; return; }
    error = '';
    onLoading('Обновление пароля');
    nuiPost('authForgot', { username: login.trim(), password: fPass });
  };

  // сила пароля (регистрация)
  $: score = (regPass.length >= 6 ? 1 : 0) + (regPass.length >= 10 ? 1 : 0)
    + (/\d/.test(regPass) && /[a-zA-Zа-яА-Я]/.test(regPass) ? 1 : 0);
  $: strengthLabel = regPass.length === 0 ? '' : score <= 1 ? 'слабый' : score === 2 ? 'средний' : 'надёжный';
  const barCls = (i, s, len) =>
    'bar' + (len > 0 && s > i ? (s <= 1 ? ' weak' : s === 2 ? ' mid' : ' strong') : '');

  // снял галочку «запомнить» на welcome → в следующий раз спросим пароль
  const onRemember = () => {
    remember = false;
    mode = 'login';
    if (!login) login = known;
  };
</script>

{#if mode === 'welcome' && known}
  <!-- ===== ЗАПОМНЕННЫЙ ВХОД (Social Club найден, вход без пароля) ===== -->
  <div class="stage">
    <div class="stagecol">
      <Brand kicker="С возвращением" />
      <div class="panel">
        <div class="panel-title">Вы уже входили</div>
        <div class="panel-sub">Мы запомнили твой Social Club на этом ПК.</div>

        <div class="profchip" style="cursor:default">
          <div class="ava">{known[0]?.toUpperCase() ?? '?'}</div>
          <div class="meta">
            <div class="lbl">Social Club найден</div>
            <div class="name">{known}</div>
          </div>
          <div class="live"></div>
        </div>

        {#if error}<div class="errtext" style="margin-bottom:10px">{error}</div>{/if}
        <button class="btn-gold" on:click={quickLogin}>Войти</button>

        <div class="checkrow" style="margin-top:18px" on:click={onRemember}>
          <div class="box on">✓</div>
          <div class="txt">Запомнить меня на этом ПК</div>
        </div>

        <div class="underrow" style="margin-top:14px">
          <span>Это не вы?</span>
          <span class="lnk" on:click={() => { mode = 'login'; remember = true; error = ''; }}>Войти в другой аккаунт</span>
        </div>
      </div>
    </div>
  </div>
{:else if mode === 'login'}
  <!-- ===== ВХОД ===== -->
  <div class="stage">
    <div class="stagecol">
      <Brand kicker="Новая история начинается" />
      <div class="panel">
        <div class="panel-title">Авторизация</div>
        <div class="panel-sub">С возвращением. Город ждёт тебя.</div>

        {#if known}
          <div class="profchip" on:click={quick ? quickLogin : () => { login = known; }}>
            <div class="ava">{known[0]?.toUpperCase() ?? '?'}</div>
            <div class="meta">
              <div class="lbl">Social Club • профиль найден</div>
              <div class="name">{known}</div>
            </div>
            <div class="live"></div>
          </div>
        {/if}
        {#if known && quick}
          <div class="panel-sub" style="margin-top:-10px">Нажми на профиль — войдёшь без пароля.</div>
        {/if}

        <div class="form">
          <div class="fld">
            <label>Логин</label>
            <input
              value={login}
              placeholder="Ваш логин"
              spellcheck="false"
              autocomplete="off"
              use:autofocus={!login}
              on:input={(e) => { login = e.target.value; clearErr(); }}
              on:keydown={(e) => e.key === 'Enter' && submitLogin()}
            />
          </div>
          <PassField
            label="Пароль" value={password} toggle {showPass}
            onEnter={submitLogin}
            onToggle={() => { showPass = !showPass; }}
            onInput={(v) => { password = v; clearErr(); }}
          />

          <div class="checkrow" on:click={() => { remember = !remember; }}>
            <div class={'box' + (remember ? ' on' : '')}>{remember ? '✓' : ''}</div>
            <div class="txt">Входить на этом компьютере без пароля</div>
          </div>

          {#if error}<div class="errtext">{error}</div>{/if}
          <button class="btn-gold" on:click={submitLogin}>Войти в город</button>
        </div>

        <div class="underrow">
          <span>Забыли пароль?</span>
          <span class="lnk" on:click={() => { mode = 'forgot'; stage = 1; error = ''; }}>Восстановить доступ</span>
        </div>
        {#if !known}
          <div class="underrow" style="margin-top:10px;padding-top:0;border-top:none">
            <span>Нет аккаунта?</span>
            <span class="lnk" on:click={() => { mode = 'register'; error = ''; }}>Создать</span>
          </div>
        {/if}
      </div>
    </div>
  </div>
{:else if mode === 'forgot'}
  <!-- ===== ВОССТАНОВЛЕНИЕ ===== -->
  <div class="stage">
    <div class="stagecol">
      <Brand kicker="Вернём доступ к истории" />
      <div class="panel">
        {#if stage === 1}
          <div class="form">
            <div>
              <div class="panel-title">Забыли пароль?</div>
              <div class="panel-sub" style="margin-bottom:0">
                Аккаунт привязан к твоему Social Club — этого достаточно, чтобы задать новый пароль.
              </div>
            </div>
            <div class="fld">
              <label>Логин аккаунта</label>
              <input
                value={login}
                placeholder="Твой логин"
                spellcheck="false"
                autocomplete="off"
                on:input={(e) => { login = e.target.value; clearErr(); }}
                on:keydown={(e) => e.key === 'Enter' && forgotCheck()}
              />
            </div>
            {#if error}<div class="errtext">{error}</div>{/if}
            <button class="btn-gold" on:click={forgotCheck}>Проверить владение</button>
          </div>
        {/if}

        {#if stage === 2}
          <div class="form">
            <div>
              <div class="panel-title">Новый пароль</div>
              <div class="panel-sub" style="margin-bottom:0">
                Владение подтверждено: «{login}» — твой аккаунт. Задай новый пароль.
              </div>
            </div>
            <div class="grid2">
              <PassField label="Новый пароль" value={fPass} onEnter={forgotReset} onInput={(v) => { fPass = v; clearErr(); }} />
              <PassField label="Повторите" value={fPass2} onEnter={forgotReset} onInput={(v) => { fPass2 = v; clearErr(); }} />
            </div>
            {#if error}<div class="errtext">{error}</div>{/if}
            <button class="btn-gold" on:click={forgotReset}>Сменить пароль</button>
          </div>
        {/if}

        {#if stage === 3}
          <div class="okwrap">
            <div class="okmark">✓</div>
            <div class="panel-title">Пароль обновлён</div>
            <div class="panel-sub" style="margin-bottom:0">Доступ восстановлен. Теперь можно войти с новым паролем.</div>
            <button class="btn-gold" style="margin-top:6px" on:click={() => { mode = 'login'; password = ''; error = ''; }}>
              Вернуться ко входу
            </button>
          </div>
        {/if}

        {#if stage !== 3}
          <div class="underrow">
            <span>Вспомнили пароль?</span>
            <span class="lnk" on:click={() => { mode = 'login'; error = ''; }}>Войти</span>
          </div>
        {/if}
      </div>
    </div>
  </div>
{:else}
  <!-- ===== РЕГИСТРАЦИЯ ===== -->
  <div class="stage">
    <div class="stagecol">
      <Brand kicker="Шаг первый — аккаунт" />
      <div class="panel">
        <div class="panel-title">Регистрация</div>
        <div class="panel-sub">Профиль Social Club не найден — создадим новый.</div>

        <div class="form">
          <div class="fld">
            <label>Логин</label>
            <input
              value={login}
              placeholder="Латиница, 3–20 символов"
              spellcheck="false"
              autocomplete="off"
              use:autofocus
              on:input={(e) => { login = e.target.value; clearErr(); }}
              on:keydown={(e) => e.key === 'Enter' && submitRegister()}
            />
          </div>

          <div class="fld">
            <label>Email</label>
            <input
              value={email}
              placeholder="Для восстановления доступа"
              spellcheck="false"
              autocomplete="off"
              on:input={(e) => { email = e.target.value; clearErr(); }}
              on:keydown={(e) => e.key === 'Enter' && submitRegister()}
            />
          </div>

          <div class="fld">
            <div class="labelrow">
              <label>Пароль</label>
              <div class="labelnote">{strengthLabel}</div>
            </div>
            <input
              type="password"
              value={regPass}
              placeholder="Минимум 6 символов"
              autocomplete="off"
              on:input={(e) => { regPass = e.target.value; clearErr(); }}
              on:keydown={(e) => e.key === 'Enter' && submitRegister()}
            />
            <div class="strength">
              <div class={barCls(0, score, regPass.length)}></div>
              <div class={barCls(1, score, regPass.length)}></div>
              <div class={barCls(2, score, regPass.length)}></div>
            </div>
          </div>

          <div class="fld">
            <label>Повторите пароль</label>
            <input
              type="password"
              value={regPass2}
              placeholder="Ещё раз"
              autocomplete="off"
              on:input={(e) => { regPass2 = e.target.value; clearErr(); }}
              on:keydown={(e) => e.key === 'Enter' && submitRegister()}
            />
          </div>

          <div class="fld">
            <div class="labelrow">
              <label>Промокод</label>
              <div class="labelnote">необязательно</div>
            </div>
            <input
              value={promo}
              placeholder="Есть код стримера? Введи его"
              spellcheck="false"
              autocomplete="off"
              on:input={(e) => { promo = e.target.value; clearErr(); }}
              on:keydown={(e) => e.key === 'Enter' && submitRegister()}
            />
          </div>

          <div class="checkrow" on:click={() => { rules = !rules; clearErr(); }}>
            <div class={'box' + (rules ? ' on' : '')}>{rules ? '✓' : ''}</div>
            <div class="txt">Принимаю <b>правила сервера</b> и согласен жить по ним</div>
          </div>

          <div class="checkrow" on:click={() => { remember = !remember; }}>
            <div class={'box' + (remember ? ' on' : '')}>{remember ? '✓' : ''}</div>
            <div class="txt">Входить на этом компьютере без пароля</div>
          </div>

          {#if error}<div class="errtext">{error}</div>{/if}
          <button class="btn-gold" on:click={submitRegister}>Создать аккаунт</button>
        </div>

        <div class="underrow note">Аккаунт привяжется к этому Social Club автоматически</div>
        <div class="underrow" style="margin-top:10px;padding-top:0;border-top:none">
          <span>Уже есть аккаунт?</span>
          <span class="lnk" on:click={() => { mode = 'login'; error = ''; }}>Войти</span>
        </div>
      </div>
    </div>
  </div>
{/if}
